module.exports = window.wp.preferences;